import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { empoweringGrowthData } from "../../Components/EmpoweringLogic/EmpoweringLogic";
import { homeBg } from "../../../../../images";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { motion } from "motion/react";
gsap.registerPlugin(ScrollTrigger);
const EmpoweringGrowth = () => {
  const location = useLocation();
  const {
    image,
    title,
    heading,
    description,
    stats = [],
    features,
  } = empoweringGrowthData[location.pathname] || empoweringGrowthData["/"];

  const cards = [
    {
      title:
        "Your dashboard shows consistent 6-figure months while you're on vacation",
      subtitle: "Complete freedom and passive success",
    },
    {
      title: "Every product launch becomes a guaranteed success story",
      subtitle: "Confidence and predictable wins",
    },
    {
      title:
        "Industry experts invite you to speak at conferences about your success",
      subtitle: "Fame, recognition, and thought leadership",
    },
    {
      title: "Competitors study your strategies while you stay ahead",
      subtitle: "Become the blueprint they follow",
    },
    {
      title: "You’re finally recognized as a true leader in the Amazon space",
      subtitle: "Authority, impact, and legacy",
    },
  ];
  useEffect(() => {
    ScrollTrigger.getAll().forEach((t) => t.kill());
    const isMobile = window.innerWidth <= 768;
    if (isMobile) return;
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: ".one",
        start: "50% 50%",
        endTrigger: ".one",
        end: "bottom 50%",
        pin: true,
        pinSpacing: false, // 🧹 removes that extra space
        scrub: true,
        anticipatePin: 1,
      },
    });

    // Step 1️⃣ - Fade + blur out first card slightly
    tl.to(".one", {
      opacity: 0.3,
      filter: "blur(10px)",
      scale: 0.97,
      duration: 1.2,
      ease: "power2.inOut",
    });

    // Step 2️⃣ - Bring in second card over the first one
    tl.fromTo(
      ".two",
      { yPercent: 100, opacity: 0 },
      {
        yPercent: 0, opacity: 1, duration: 1.2,
        ease: "power2.out"
      },
      "<" // overlap with the blur for smooth transition
    );

    return () => ScrollTrigger.getAll().forEach((t) => t.kill());
  }, []);


  return (
    <>
      <div className="py-lg-5 text-center empowering-growth ">
        <div className="card one">
          <motion.h2
            className="hero-heading text-white"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.1 }}
            viewport={{ once: false }}
          >
            Imagine Your Amazon Business Running Itself While You Focus on What Matters          </motion.h2>
          <motion.p className="hero-sub-text text-white mt-2 pt-4"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
            viewport={{ once: false }} >
            Picture the perfect life after achieving Amazon success          </motion.p>
        </div>
        <div className="card two">
          {/* Row 1 - 2 Cards */}
          <div className="row justify-content-end gy-4 me-0 ms-0">
            {[cards[0], cards[1]].map((card, index) => (
              <div className="col-lg-5 col-md-6 col-12 col-sm-12 " key={`row1-${index}`}>
                <div className="card text-white bg-opacity-75 shadow-lg rounded p-4 h-100 card-custom">
                  <h5 className="card-custom-title">{card.title}</h5>
                  <p className="fst-italic mt-2">{card.subtitle}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Row 2 - 1 Card */}
          <div className="row justify-content-center gy-4 mt-3 me-0 ms-0">
            <div className="col-md-6 col-12 col-sm-12 d-flex justify-content-center align-item-center">
              <div className="card text-white bg-opacity-75 shadow-lg rounded p-4 h-100 card-custom">
                <h5 className="card-custom-title">{cards[2].title}</h5>
                <p className="fst-italic mt-2">{cards[2].subtitle}</p>
              </div>
            </div>
          </div>

          {/* Row 3 - 2 Cards */}
          <div className="row justify-content-end gy-4 mt-3 me-0 ms-0">
            {[cards[3], cards[4]].map((card, index) => (
              <div className="col-lg-5 col-md-6 col-12" key={`row3-${index}`}>
                <div className="card text-white bg-opacity-75 shadow-lg rounded p-4 h-100 card-custom">
                  <h5 className="card-custom-title">{card.title}</h5>
                  <p className="fst-italic mt-2">{card.subtitle}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="text-center mt-5">
            <button className="toggle-btn active"> <Link to={"/signin"} className='text-decoration-none'>Make This My Reality</Link></button>
          </div>

        </div>
      </div>
    </>
  );
};

export default EmpoweringGrowth;
